import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import AppHeader from "../components/app-header";
import Artists from "../components/recommendations/artists";
import Genres from "../components/recommendations/genres";
import Tracks from "../components/recommendations/tracks";
import Result from "../components/result";
import UserProfile from "../components/user-profile";
import { useRecommendations } from "../lib/recommendations";
import { useSpotify } from "../lib/useSpotify";
import RecommendationsContextProvider from "../providers/recommendations-context-provider";
import SpotifyContextProvider from "../providers/spotify-context-provider";

export const Route = createFileRoute("/")({
	component: () => (
		<SpotifyContextProvider>
			<RecommendationsContextProvider>
				<Index />
			</RecommendationsContextProvider>
		</SpotifyContextProvider>
	),
});

function Index() {
	const spotify = useSpotify();
	const { recommendations, ready } = useRecommendations();

	const { data: results, refetch } = useQuery({
		queryKey: ["recommendations", recommendations],
		queryFn: () => spotify?.recommendations.get(recommendations),
		placeholderData: keepPreviousData,
		enabled: false,
	});

	const { data: features } = useQuery({
		queryKey: ["features", recommendations.seed_tracks],
		queryFn: () =>
			spotify?.tracks.audioFeatures(results?.tracks.map(({ id }) => id) || []),
		enabled: (results?.tracks.length ?? 0) > 0,
	});

	return (
		<>
			<div className="space-y-4 p-4 overflow-y-scroll">
				<UserProfile />
				<AppHeader />
				<Tracks />
				<Artists />
				<Genres />
			</div>
			<section
				id="results"
				className="overflow-y-scroll col-span-3 text-xs p-4 m-4 bg-white border border-dark rounded-lg"
			>
				<div className="grid grid-cols-2 lg:grid-cols-5 gap-2 overflow-y-scroll">
					{results?.tracks?.map((track) => (
						<Result
							key={`${track.id}result`}
							track={track}
							features={features?.find((f) => f.id === track.id)}
						/>
					))}
				</div>
				<div className="absolute bottom-10 right-12">
					<button
						type="submit"
						onClick={() => refetch()}
						disabled={!ready}
						className="cursor-pointer p-1 px-1.5 bg-white border border-dark rounded-lg uppercase hover:bg-active-light hover:border-active-dark transition-all duration-100 font-medium"
					>
						💡 Get Recommendations
					</button>
				</div>
			</section>
		</>
	);
}
